// extracted by css-extract-rspack-plugin
export default {"TabBar":"MV4c8","RadioInput":"Rl225","Tab":"Ecjgu","active":"f1CUG","inactive":"WdpY_","disabled":"DvpRM"};